import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { PrecioControlContent } from './components/PrecioControlContent';

export default function PrecioControl() {
    return (
        <>
            <MainContent
                component={<PrecioControlContent />}
                titulo='Autorización Precio Control'	
                noBackground
                tableMaxWidth
            />
        </>
    );

};
